import AppDialog from '../../components/app_dialog'
import { TextField, Select } from '@cinesend/ui-kit'
import { useState } from 'react'
import useStore from '../../hooks/use_store'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

const CreateUserModal = ({ onClose }) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [roleID, setRoleID] = useState('')
  const [orgID, setOrgID] = useState('')
  const { createModel } = useStore()
  const { data: roles } = useQuery(['roles'])
  const { data: organizations } = useQuery(['organizations'])
  const navigate = useNavigate()

  const create = () => {
    createModel.mutate(
      {
        endpoint: 'users',
        data: {
          name,
          email,
          password,
          role_id: roleID,
          organization_id: orgID,
        },
      },
      {
        onSuccess: (res) => {
          navigate(`/settings/users/${res.data.user.id}`)
        },
      }
    )
  }
  return (
    <AppDialog
      title='Create user'
      onClose={onClose}
      confirmText='Create'
      onConfirm={() => create()}
      confirmDisabled={
        name.length === 0 || email.length === 0 || roleID.length === 0 || orgID.length === 0 || password.length <= 7
      }
    >
      <div className='space-y-2'>
        <TextField value={name} label='Name' onChange={(e) => setName(e.target.value)} />
        <TextField value={email} label='Email' onChange={(e) => setEmail(e.target.value)} />
        <TextField value={password} label='Password' onChange={(e) => setPassword(e.target.value)} type='password' />
        <Select
          fullWidth
          label='Role'
          value={roleID ? String(roleID) : null}
          options={roles?.map((opt) => ({ value: String(opt.id), label: opt.label })) ?? []}
          onValueChange={(id) => setRoleID(Number(id))}
        />
        <Select
          fullWidth
          label='Organization'
          value={orgID ? String(orgID) : null}
          options={organizations?.map((opt) => ({ value: String(opt.id), label: opt.name })) ?? []}
          onValueChange={(id) => setOrgID(Number(id))}
        />
      </div>
    </AppDialog>
  )
}

export default CreateUserModal
